export const environment = {
  name: 'production',
  production: true,
  apiUrl: 'https://itask.neatsoft.io/api/',
  socket: {
    url: 'https://itask.neatsoft.io',
    options: {
      path: '/socket',
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 20000,
      transports: ['websocket', 'polling'],
      upgrade: true,
      forceNew: true,
      rejectUnauthorized: false,
      autoConnect: true,
      query: {},
      EIO: 3,
    },
  },
};
